export const EMPTY_LINKS = {
  links: [],
  active: null,
}
